/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */

if(!window.GS) GS={};
if(!window.GS.Filters) GS.Filters={};

GS.Filters.InnerShadowFilter=new Class({
    Extends: GS.Filters.BaseFilter,
    class_name:'GS.Filters.InnerShadowFilter',
    options:{
        'debug':0,
        'dx': 0,
        'dy':0,
        'color': '#000',
        'blur':10,
        'opacity': 0.5,
        'inType':'SourceAlpha'
    },
    filter: {
        'id':0,
        'container':null,
        'blur':null,
        'offset':null,
        'color':null
    }
    /*initialize:function(conf){
        this.parent(conf);
    }*/
});


/**
 * Update the element Drop Shadow Filter
 * @param {type} obj
 * @returns {void}
 */
GS.Filters.InnerShadowFilter.prototype.update=function(obj){

    if(obj.dx  !==  this.options.dx) this.filter.offset.setAttribute('dx',obj.dx);
    if(obj.dy  !==  this.options.dy) this.filter.offset.setAttribute('dy',obj.dy);

    if(obj.color.a  !==  this.options.color.a) this.filter.flood.setAttribute('flood-opacity',obj.color.a);
    /*if(obj.color.r  !==  this.options.color.r || obj.color.g  !==  this.options.color.g || obj.color.b  !==  this.options.color.b){
        var rbgValue = `rgb(${obj.color.r || 0 },${obj.color.g || 0},${obj.color.b || 0})`;
        this.filter.flood.setAttribute('flood-color', rbgValue);
    }*/


    if(obj.color.r  !==  this.options.color.r || obj.color.g  !==  this.options.color.g || obj.color.b  !==  this.options.color.b){
       // var rbgValue = `rgb(${obj.color.r || 0 },${obj.color.g || 0},${obj.color.b || 0})`;
        this.filter.colorR.setAttribute('tableValues', obj.color.r);
        this.filter.colorG.setAttribute('tableValues', obj.color.g);
        this.filter.colorB.setAttribute('tableValues', obj.color.b);
    }

    if(obj.blur !== this.options.blur) this.filter.blur.setAttribute('stdDeviation', obj.blur);


    if(obj.display !== this.options.display) {
        this.options.display = obj.display;
        this.toggleVisibility();
    }

    this.setOptions(obj);

};

/**
 * Apply/Attach filter to element
 * @param {SVG Element} ele
 * @returns {void}
 */
GS.Filters.InnerShadowFilter.prototype.applyTo=function(ele){

    //ele.node.style['filter']="url('#"+this.filter.id+"')";
    (ele.node || ele).setAttribute('filter',"url('#"+this.filter.id+"')");
    this.toggleVisibility();

    //ele.node.style['-webkit-filter']="url('#"+this.filter.id+"')";
};

GS.Filters.InnerShadowFilter.prototype.toggleVisibility=function(){
    var qPattern = `[filter="url('#${this.filter.id}')"]`;
    var eles = document.querySelectorAll(qPattern);
    Array.prototype.map.call(eles, function(el){
        //el.className = (!this.options.display) ? 'hide' : '';
        el.setAttribute('class', (!this.options.display) ? 'hide' : '');
        el.setAttribute('data-export', (!this.options.display) ? 'no' : 'yes');
        el.style.display = (!this.options.display) ? 'none' : 'block';
    }.bind(this))
};


GS.Filters.InnerShadowFilter.prototype.getFilterContent=function(){

    return `
        <!-- Shadow Offset -->
         <feOffset dx='${this.options.dx}' dy='${this.options.dy}'/>
    
         <!-- Shadow Blur -->
         <feGaussianBlur stdDeviation='${this.options.blur}' result='offset-blur'/>
    
         <!-- Invert the drop shadow to create an inner shadow -->
         <feComposite operator='out' in='SourceGraphic' in2='offset-blur' result='inverse'/>
    
         <!-- Shadow Opacity -->
         <feFlood flood-opacity='${this.options.color.a || 0.5}' result='color' />
    
         <!-- Clip the inside shadow -->
         <feComposite operator="in" in="color" in2="inverse" result="inner-shadow"></feComposite>
         
         
         <!-- Colorize the shadow -->
         <feComponentTransfer in="inner-shadow" >
           <feFuncR type="discrete" tableValues="${this.options.color.r || 0 }"/>
           <feFuncG type="discrete" tableValues="${this.options.color.g || 0 }"/>
           <feFuncB type="discrete" tableValues="${this.options.color.b || 0 }"/>
       </feComponentTransfer>
    
         <!-- Put shadow over original object -->
         <!--<feComposite operator='over' in='shadow' in2='SourceGraphic' />--> 
    `;
};

GS.Filters.InnerShadowFilter.prototype.createFilter=function(){
    var fID,feGaussianBlur,feOffset,cMatrix,feColorMatrix,
    feMerge,feMergeShadow,feMergeSurce;
    
    //Add defs group
    var f=new Element('filter',{'id':this.filter.id, 'color-interpolation-filters':'sRGB'});
    this.filter.container = f;



    var fTMPL = this.getFilterContent();
    f.innerHTML = fTMPL;

    this.filter.offset = f.querySelector('feoffset') || f.querySelector('feOffset');
    this.filter.flood = f.querySelector('feflood') || f.querySelector('feFlood');
    this.filter.blur = f.querySelector('fegaussianblur') || f.querySelector('feGaussianBlur');

    this.filter.colorR = f.querySelector('fefuncr') || f.querySelector('feFuncR');
    this.filter.colorG = f.querySelector('fefuncg') || f.querySelector('feFuncG');
    this.filter.colorB = f.querySelector('fefuncb') || f.querySelector('feFuncB');

    //this.filter.container.adopt([feGaussianBlur,feOffset,feColorMatrix]);
    this.defs.adopt(f);
    this.toggleVisibility();
};

